<samweb-loading-indicator fxFlexFill [showForAllLongRunningContextCategories]="true" [runForever]="false">
   <div class="sam-login-container" tabindex="0" fxLayout="row" fxLayoutAlign="center">
      <div fxFlexAlign="center">
         <router-outlet></router-outlet>
      </div>
      <div class="version-info">{{ clientVersion.semVer }}</div>
   </div>
</samweb-loading-indicator>
